import { isNumber } from 'lodash-es';

import { SparklineYAxisProps } from '../types/sparkline-y-axis-props.js';

export const getShowContextValues = (
  yAxis: SparklineYAxisProps,
  contextValues: { min: number; max: number },
) => {
  const { min, max } = contextValues;

  let showContextMin = true;
  let showContextMax = true;

  if (isNumber(yAxis.min)) {
    showContextMin = yAxis.min <= min;
  }

  if (isNumber(yAxis.max)) {
    showContextMax = yAxis.max >= max;
  }

  return { showContextMin, showContextMax };
};
